import { combineReducers } from 'redux';
import { campaignsReducer } from './campaigns.state';
import { campaignsMiddleware } from './campaigns.middlewares';
import { campaignsFiltersReducers } from './campaigns-filter/campaigns-filter.state';
import { campaignsFilterMiddlewares } from './campaigns-filter/campaigns-filter.middlewares';

export const campaignsReducers = combineReducers({
    currentCampaigns: campaignsReducer,
    campaignsFilters: campaignsFiltersReducers,
});

export const campaignsMiddlewares = [
    campaignsMiddleware,
    ...campaignsFilterMiddlewares,
];
